interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';

  return (
    <div className={`flex flex-col ${alignment} max-w-2xl`}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium px-3 py-1 rounded-full bg-secondary-100 text-secondary-900">
        <i className="ri-leaf-line" />
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3 md:mt-4">{title}</h2>
      {desc && <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}